var map = {
	"./android-icon-144x144.png": "6dkk",
	"./android-icon-192x192.png": "UNtw",
	"./android-icon-256x256.png": "1wfj",
	"./android-icon-36x36.png": "al9C",
	"./android-icon-48x48.png": "58YN",
	"./android-icon-72x72.png": "gzWc",
	"./android-icon-96x96.png": "teVX",
	"./apple-icon-114x114.png": "E0W+",
	"./apple-icon-120x120.png": "i9Dk",
	"./apple-icon-144x144.png": "2RVx",
	"./apple-icon-152x152.png": "fUR2",
	"./apple-icon-180x180.png": "48DL",
	"./apple-icon-57x57.png": "o3v5",
	"./apple-icon-60x60.png": "lFlA",
	"./apple-icon-72x72.png": "hhZ1",
	"./apple-icon-76x76.png": "Oq1p",
	"./apple-icon-precomposed.png": "JBuq",
	"./apple-icon.png": "RAL+",
	"./browserconfig.xml": "9Uo1",
	"./favicon-16x16.png": "ebsk",
	"./favicon-32x32.png": "SFfH",
	"./favicon-96x96.png": "kySM",
	"./favicon.ico": "Dxoc",
	"./ms-icon-144x144.png": "4TYF",
	"./ms-icon-150x150.png": "mJKJ",
	"./ms-icon-310x310.png": "7cNb",
	"./ms-icon-70x70.png": "LVlq",
	"./safari-pinned-tab.svg": "s3Pj"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zTjj";